import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'

function ConfirmationModalCommon(props) {
    const { isConfimationModalOpen, setIsConfimationModalOpen, finalAction,message } = props
    return (
        <>
            <Modal show={isConfimationModalOpen} onHide={() => setIsConfimationModalOpen()} centered>
                <Modal.Body><b>{message? message:''} </b></Modal.Body>
                <Modal.Footer className='confirationModalfooter'>
                    <Button variant="light" onClick={() => setIsConfimationModalOpen()}><b>No</b></Button>
                    <Button variant="light" onClick={finalAction}><b>Yes</b></Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

ConfirmationModalCommon.propTypes = {
    dispatch: PropTypes.func,
    isConfimationModalOpen: PropTypes.bool,
    setIsConfimationModalOpen: PropTypes.func,
    finalAction: PropTypes.func,
    message:PropTypes.string
}

ConfirmationModalCommon.defaulProps = {
    dispatch: noop,
    isConfimationModalOpen: false,
    setIsConfimationModalOpen: noop,
    finalAction: noop,
    message:''
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ConfirmationModalCommon)